import React from 'react';

interface OwnProps {
    color: string;
}

const ChatIcon = ({ color }: OwnProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
            <path
                d="M5.5 8H5.50667M8.5 8H8.50667M11.5 8H11.5067M8.5 14C11.8137 14 14.5 11.3137 14.5 8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 8.7981 2.65582 9.5598 2.93871 10.2563C2.99285 10.3897 3.01992 10.4563 3.032 10.5102C3.04381 10.5629 3.04813 10.6019 3.04814 10.6559C3.04814 10.7111 3.03812 10.7713 3.01807 10.8916L2.62275 13.2635C2.58135 13.5119 2.56065 13.6361 2.59917 13.7259C2.63289 13.8045 2.69552 13.8671 2.77412 13.9008C2.86393 13.9393 2.98812 13.9186 3.23651 13.8772L5.60843 13.4819C5.72872 13.4619 5.78887 13.4519 5.84409 13.4519C5.8981 13.4519 5.93711 13.4562 5.98981 13.468C6.04369 13.4801 6.11035 13.5072 6.24366 13.5613C6.9402 13.8442 7.7019 14 8.5 14ZM5.83333 8C5.83333 8.1841 5.6841 8.33333 5.5 8.33333C5.31591 8.33333 5.16667 8.1841 5.16667 8C5.16667 7.81591 5.31591 7.66667 5.5 7.66667C5.6841 7.66667 5.83333 7.81591 5.83333 8ZM8.83333 8C8.83333 8.1841 8.6841 8.33333 8.5 8.33333C8.31591 8.33333 8.16667 8.1841 8.16667 8C8.16667 7.81591 8.31591 7.66667 8.5 7.66667C8.6841 7.66667 8.83333 7.81591 8.83333 8ZM11.8333 8C11.8333 8.1841 11.6841 8.33333 11.5 8.33333C11.3159 8.33333 11.1667 8.1841 11.1667 8C11.1667 7.81591 11.3159 7.66667 11.5 7.66667C11.6841 7.66667 11.8333 7.81591 11.8333 8Z"
                stroke={color ?? color}
                strokeOpacity="0.61"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChatIcon;
